<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center flex-row-reverse">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pl-40">
                    <h3>安全、可信賴的選擇</h3>
                    <p>
                        Trinka 將資料安全與隱私保護放在首位。您的所有資料皆經高度加密並安全儲存，僅您本人可存取，且可隨時從儀表板中刪除。
                    </p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="/assets/images/enterprise/safe-secure.webp" width="532" height="362" alt="safe" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2 pt-0">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="list-wrapper-content-2 pr-40">
                    <h3>關於 Trinka</h3>
                    <p>
                        Trinka 採用先進的機器學習（ML）與自然語言處理技術（NLP），專為學術與專業寫作設計。其 AI 訓練資料涵蓋醫學、生命科學、工程、人文、商管、藝術等多元領域，確保修正建議貼近實際學術需求。
                    </p>
                    <p>Trinka 由一支由語言學家、編輯、資料科學家與工程師組成的團隊開發，致力於打造無障礙溝通的未來。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="list-wrapper-image">
                    <img src="/assets/images/enterprise/about-ai.webp" width="532" height="373" alt="About Trinka" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>
